// assets/pdp.js · complementos visuais da página de produto
// - indicador de progresso + contador da galeria (mobile)
// - marca a primeira foto visível (destaque no desktop)
// - nome da cor e do tamanho escolhidos ao lado do rótulo
// - barra de compra fixa no mobile quando o botão principal sai da tela
// Não altera a lógica do product.js: só observa o que ele faz.
(function () {
  function ready(fn) {
    if (document.readyState !== 'loading') fn();
    else document.addEventListener('DOMContentLoaded', fn);
  }

  ready(function () {
    var root = document.querySelector('.pdp .product-page');
    if (!root) return;

    var gallery = root.querySelector('.product-gallery-grid');
    var progress = root.querySelector('[data-pdp-progress]');
    var count = root.querySelector('[data-pdp-count]');
    var mediaEls = gallery ? Array.prototype.slice.call(gallery.querySelectorAll('.product-media')) : [];

    function visible() {
      return mediaEls.filter(function (el) { return !el.classList.contains('is-hidden'); });
    }

    // ---------- galeria ----------
    var lastTotal = -1;
    function buildProgress() {
      var v = visible();
      mediaEls.forEach(function (el) { el.classList.remove('is-first-visible'); });
      if (v[0]) v[0].classList.add('is-first-visible');
      if (!progress) return;
      if (v.length === lastTotal) { updateIndex(); return; }
      lastTotal = v.length;
      progress.innerHTML = '';
      if (v.length <= 1) { if (count) count.textContent = ''; return; }
      for (var i = 0; i < v.length; i++) progress.appendChild(document.createElement('i'));
      updateIndex();
    }

    function updateIndex() {
      var v = visible();
      if (!gallery || v.length <= 1) return;
      var w = gallery.clientWidth || 1;
      var idx = Math.round(gallery.scrollLeft / w);
      idx = Math.max(0, Math.min(idx, v.length - 1));
      var bars = progress ? progress.children : [];
      for (var i = 0; i < bars.length; i++) bars[i].classList.toggle('is-on', i === idx);
      if (count) count.textContent = (idx + 1) + ' / ' + v.length;
    }

    if (gallery) {
      var raf = 0;
      gallery.addEventListener('scroll', function () {
        if (raf) return;
        raf = requestAnimationFrame(function () { raf = 0; updateIndex(); });
      }, { passive: true });
      // product.js mostra/esconde fotos por cor trocando a classe is-hidden
      var lastSig = '';
      var sig = function () { return mediaEls.map(function (el) { return el.classList.contains('is-hidden') ? '0' : '1'; }).join(''); };
      lastSig = sig();
      new MutationObserver(function () {
        var now = sig();
        if (now === lastSig) return; // ignora as classes que este próprio script troca
        lastSig = now;
        lastTotal = -1;
        buildProgress();
      }).observe(gallery, { subtree: true, attributes: true, attributeFilter: ['class'] });
      window.addEventListener('resize', updateIndex, { passive: true });
    }
    buildProgress();

    // ---------- rótulos de cor e tamanho ----------
    var colorName = root.querySelector('[data-pdp-color-name]');
    var sizeName = root.querySelector('[data-pdp-size-name]');
    var sizes = root.querySelector('.product-sizes');
    var stickyVariant = document.querySelector('[data-pdp-sticky-variant]');

    function currentColor() {
      var c = root.querySelector('.product-colors .cp-swatch__input:checked');
      return c ? c.value : '';
    }
    function currentSize() {
      var s = sizes ? sizes.querySelector('.size-swatch__input:checked') : null;
      return s ? s.value : '';
    }
    function syncLabels() {
      var c = currentColor();
      var s = currentSize();
      if (colorName && c) colorName.textContent = c;
      if (sizeName) sizeName.textContent = s;
      if (stickyVariant) stickyVariant.textContent = [c, s].filter(Boolean).join(' · ');
      syncSticky();
    }

    root.addEventListener('change', function (e) {
      if (e.target && e.target.matches('.cp-swatch__input, .size-swatch__input')) setTimeout(syncLabels, 0);
    });
    if (sizes) new MutationObserver(function () { setTimeout(syncLabels, 0); }).observe(sizes, { childList: true });

    // ---------- barra de compra fixa ----------
    var sticky = document.querySelector('[data-pdp-sticky]');
    var stickyBtn = sticky ? sticky.querySelector('[data-pdp-sticky-btn]') : null;
    var stickyPrice = sticky ? sticky.querySelector('[data-pdp-sticky-price]') : null;
    var mainActions = root.querySelector('[data-pdp-main-actions]');
    var addBtn = root.querySelector('.product-add');
    var mq = window.matchMedia('(max-width: 989px)');

    function syncSticky() {
      if (!sticky) return;
      var priceNow = root.querySelector('.price-current');
      if (stickyPrice && priceNow) stickyPrice.textContent = priceNow.textContent.trim();
      if (stickyBtn && addBtn) stickyBtn.disabled = !!addBtn.disabled;
    }

    function setSticky(on) {
      if (!sticky) return;
      on = on && mq.matches;
      sticky.classList.toggle('is-visible', on);
      sticky.setAttribute('aria-hidden', on ? 'false' : 'true');
      if (stickyBtn) stickyBtn.tabIndex = on ? 0 : -1;
      document.body.classList.toggle('pdp-sticky-on', on);
    }

    if (sticky && mainActions && 'IntersectionObserver' in window) {
      new IntersectionObserver(function (entries) {
        var e = entries[0];
        // aparece só depois que o botão principal passou para cima da tela
        setSticky(!e.isIntersecting && e.boundingClientRect.top < 0);
      }, { threshold: 0 }).observe(mainActions);
      mq.addEventListener && mq.addEventListener('change', function () { if (!mq.matches) setSticky(false); });
    }

    if (stickyBtn && addBtn) {
      stickyBtn.addEventListener('click', function () {
        if (addBtn.disabled) return;
        addBtn.click(); // usa o mesmo fluxo do botão principal (abre a sacola)
      });
      // product.js liga/desliga o botão principal; espelha na barra fixa
      new MutationObserver(syncSticky).observe(addBtn, { attributes: true, attributeFilter: ['disabled', 'class'] });
    }
    var priceRoot = root.querySelector('.product-price');
    if (priceRoot) new MutationObserver(syncSticky).observe(priceRoot, { subtree: true, childList: true, characterData: true });

    syncLabels();
  });
})();
